export function handleAriaLabelChange(host: HTMLElement, label: string): void {
  const hasLabel = typeof label === 'string' && label.length > 0;

  if (hasLabel) {
    host.setAttribute('role', 'img');
    host.setAttribute('aria-label', label);
    host.removeAttribute('aria-hidden');
  } else {
    host.removeAttribute('role');
    host.removeAttribute('aria-label');
    host.setAttribute('aria-hidden', 'true');
  }
}
